/** Navigation du PDA : 4 onglets fixes en bas, le reste dans « Plus ». Règles pures. */
export type PdaTab = { to: string; label: string };

export const PDA_TABS: readonly PdaTab[] = [
  { to: '/mode-stock?vue=maj', label: 'Scan' },
  { to: '/mode-stock?vue=reception', label: 'Réception' },
  { to: '/mode-stock?vue=inventaire', label: 'Inventaire' },
  { to: '/mode-stock?vue=stocks', label: 'Stocks' },
];

/** Onglet actif : même page et même vue (Mode Stock sans vue = Scan). */
export const isTabActive = (tab: PdaTab, pathname: string, search: string): boolean => {
  const [path, query] = tab.to.split('?');
  if (path !== pathname) return false;
  const want = new URLSearchParams(query).get('vue');
  const have = new URLSearchParams(search).get('vue') ?? 'maj';
  return want === have;
};
